export enum HttpRequestType {
  GET,
	POST,
	PUT,
	DELETE
}